import React from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

const WishlistNotRemovedAlert = ({ message, onClose }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 340,
          borderRadius: 4,
          textAlign: "center",
          p: 3,
        }}
        elevation={10}
      >
        <CardContent>
          <FavoriteBorderIcon
            sx={{
              fontSize: 70,
              color: "gray",
              mb: 2,
            }}
          />

          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Removal Failed
          </Typography>

          <Typography variant="body2" color="text.secondary" mb={3}>
            {message}
          </Typography>

          <Button
            variant="contained"
            color="error"
            fullWidth
            onClick={onClose}
            sx={{ borderRadius: 3 }}
          >
            OK
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default WishlistNotRemovedAlert;